import { render, staticRenderFns } from "./ChatWish.vue?vue&type=template&id=35a49118&scoped=true"
import script from "./ChatWish.vue?vue&type=script&lang=js"
export * from "./ChatWish.vue?vue&type=script&lang=js"
import style0 from "./ChatWish.vue?vue&type=style&index=0&id=35a49118&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a49118",
  null
  
)

export default component.exports